import http from '../utility/http';

export default {
    namespaced: true,
    state: {
        claims: [],
        error: undefined
    },
    getters: {
        getClaim: (state) => (id) => {
            return state.claims.find(c => {
                return c.id === id;
            });
        },
        getClaims(state) {
            return state.claims;
        },
        getRootClaims: function(state) {
            return state.claims.filter(c => {
                return c.isRoot === true;
            });
        }
    },
    actions: {
        async loadClaim(context, id) {
            let claim = context.getters.getClaim(id);
            if (!claim) {
                try {
                    const claim = await http.get(`/claims/${id}`).data;
                    context.commit('addClaim', claim.data);
                } catch (error) {
                    context.commit('error', error);
                }
            }
            return claim;
        },
        async loadClaims(context) {
            try {
                const claims = await http.get('/claims');
                context.commit('setClaims', claims.data);
            } catch (error) {
                context.commit('error', error);
            }
        },
        async createClaim(context, claim) {
            try {
                const createdClaim = await http.post('/claims', {
                    id: claim.id,
                    title: claim.title,
                    body: claim.body
                });
                context.commit('addClaim', createdClaim.data);
            } catch (error) {
                context.commit('error', error);
            }
        },
        async createChildClaim(context, claim) {
            try {
                const createdClaim = await http.post(`/claims/${claim.parentId}/${claim.type}`, {
                    id: claim.id,
                    title: claim.title,
                    body: claim.body
                });
                context.commit('addClaim', createdClaim.data);
                context.dispatch('loadClaims');
            } catch (error) {
                context.commit('error', error);
            }
        },
        async updateClaim(context, claim) {
            try {
                await http.put(`/claims/${claim.id}`, claim);
                context.commit('updateClaim', claim);
            } catch (error) {
                context.commit('error', error);
            }
        },
        async updateClaimPercents(context, claimData) {
            try {
                const claim = await http.put(`/claims/${claimData.id}/percents`, claimData.percents);
                context.commit('updateClaim', claim.data);
            } catch (error) {
                context.commit('error', error);
            }
        },
        async invite(context, inviteData) {
            try {
                await http.post(`/claims/${inviteData.id}/invite-user`, {
                    email: inviteData.email
                });
            } catch (error) {
                context.commit('error', error);
            }
        }
    },
    mutations: {
        setClaims(state, claims) {
            state.claims = claims;
        },
        addClaim(state, claim) {
            state.claims.push(claim);
        },
        updateClaim(state, claim) {
            const storeClaim = state.claims.find(c => c.id === claim.id);
            if (!storeClaim) {
                throw new Error("Updated claim not in store")
            }
            Object.assign(storeClaim, claim);
        },
        error(state, error) {
            state.error = error;
        }
    }
}